import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { QuickActions, QuickActionsItem } from 'src/shared';
import { useCloseSidebar } from 'src/shared/InfoSidebar/hooks';
import { faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { getUpdateCacheOnDeleteMp, useDeleteMp, useLoadMp } from 'src/models/matchingProfiles/hooks';
import { trackMPEditDelete } from 'src/segment/events';
import { useNavigate } from 'react-router-dom';
import { confirm, notification } from 'src/common';
import modalStyles from 'src/common/Modal/index.module.scss';
import { Paths } from 'src/pages/paths';

export const MpQuickActions: FC = () => {
  const { t } = useTranslation();

  const mp = useLoadMp();
  const currentMp = mp.data;

  const [deleteMp] = useDeleteMp();
  const closeSidebar = useCloseSidebar();

  const navigate = useNavigate();

  const onDeleteMp = useCallback(() => {
    if (currentMp) {
      confirm.confirm({
        title: t('Tenders.removeMatchingProfileConfirmTitle'),
        content: t('Tenders.removeMatchingProfileConfirmQuestion'),
        okText: t('Common.delete'),
        cancelText: t('Common.cancel'),
        className: modalStyles.confirmModal,
        centered: true,
        onOk() {
          trackMPEditDelete({ id: currentMp.id, name: currentMp.name });
          deleteMp({
            variables: { id: currentMp.id },
            update: getUpdateCacheOnDeleteMp(currentMp.id),
            optimisticResponse: {
              __typename: 'Mutation',
              deleteMatchingProfile: true
            }
          })
            .then(() => {
              closeSidebar();
              navigate({
                pathname: Paths.MONITORING
              });
            })
            .catch(() => {
              notification.error({
                description: t('Common.unknownErrorDesc'),
                message: t('Common.unknownError')
              });
            });
        }
      });
    }
  }, [currentMp, t, deleteMp, closeSidebar, navigate]);

  return (
    <QuickActions>
      <QuickActionsItem
        onClick={onDeleteMp}
        title={t('Tenders.removeMatchingProfileConfirmTitle')}
        key={'delete'}
        icon={faTrashCan}
        danger
      />
    </QuickActions>
  );
};

export default MpQuickActions;
